import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";

import * as styles from "./Main.module.css";

export const Main = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div>
        <h1>Оптимизируй взаиморасчёты — освободи капитал</h1>

        <Button
          onClick={() => navigate("/company_info")}
          className={styles.button}
        >
          Начать
        </Button>
      </div>
    </div>
  );
};
